import PropTypes from 'prop-types';
import React from 'react';
import CometaSelect from './CometaSelect';
import { withEnums } from '../../../decorators';
import { Util } from '../../../services';
var sortByCial = Util.createCialCountrySort({
  valueProperty: 'value',
  labelProperty: 'label'
});

function CountryDropdown(_ref) {
  var cialOnly = _ref.cialOnly,
      country = _ref.country,
      user = _ref.user,
      isClearable = _ref.isClearable,
      label = _ref.label,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      touched = _ref.touched,
      error = _ref.error,
      cialCountries = _ref.cialCountries,
      classNamePrefix = _ref.classNamePrefix,
      input = _ref.input,
      meta = _ref.meta,
      id = _ref.id;
  var filterFunction;
  var inputObj = input || {
    onChange: onChange || Util.noop,
    onFocus: onFocus || Util.noop,
    onBlur: onBlur || Util.noop
  };
  var metaObj = meta || {
    touched: touched,
    error: error
  };

  if (cialOnly) {
    filterFunction = function filterFunction(cometaCountry) {
      return cialCountries.some(function (cc) {
        return cc.iso_alpha_3 === cometaCountry.code;
      });
    };
  }

  return React.createElement(CometaSelect, {
    id: id,
    listName: 'country',
    placeholder: placeholder,
    country: country,
    language: user && user.getLanguage(),
    isClearable: isClearable,
    label: label,
    handleChange: onChange,
    meta: metaObj,
    input: inputObj,
    filterWith: filterFunction,
    sortWith: sortByCial,
    classNamePrefix: classNamePrefix
  });
}

var enumCountryShape = PropTypes.shape({
  code: PropTypes.string,
  iso_alpha_3: PropTypes.string,
  continent: PropTypes.string,
  phone_code: PropTypes.string,
  states: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    title: PropTypes.string.isRequired
  })),
  title: PropTypes.string.isRequired
});
CountryDropdown.propTypes = {
  isClearable: PropTypes.bool,
  cialOnly: PropTypes.bool.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  touched: PropTypes.bool,
  error: PropTypes.string,
  cialCountries: PropTypes.arrayOf(enumCountryShape),
  classNamePrefix: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  }),
  input: PropTypes.shape({
    value: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  })
};
CountryDropdown.defaultProps = {
  isClearable: false,
  cialOnly: false,
  placeholder: 'Country',
  classNamePrefix: 'SearchableDropdown'
};
var CountryDropdownWithEnums = withEnums('cialCountries')(CountryDropdown);
export default CountryDropdownWithEnums;